<template>
  <HeadlessDisclosure
    v-slot="{ open }"
    class="lg:py-6 py-4 flex flex-col justify-center"
  >
    <div
      class="w-full"
      itemscope
      itemprop="mainEntity"
      itemtype="https://schema.org/Question"
    >
      <HeadlessDisclosureButton
        class="flex w-full justify-between items-center text-title-sm text-left p-0"
      >
        <div v-if="!hasTitleSlot('title')">
          <h3
            itemprop="name"
            class="lg:text-title-sm text-body-lg text-gray-200 font-normal mr-1"
          >
            {{ item.title }}
          </h3>
        </div>
        <div v-if="!hasTitleSlot('title')">
          <Icon
            v-if="item.isArray"
            :name="open ? 'tabler:chevron-up' : 'tabler:chevron-down'"
            class="text-gray-200"
          />
          <Icon
            v-else
            :name="open ? 'tabler:minus' : 'tabler:plus'"
            class="text-gray-200"
          />
        </div>
        <slot name="title" :open="open" />
      </HeadlessDisclosureButton>
      <TransitionExpand>
        <HeadlessDisclosurePanel
          v-slot="{ close }"
          v-show="open"
          :unmount="false"
          itemscope
          itemprop="acceptedAnswer"
          itemtype="https://schema.org/Answer"
          class="w-full lg:mt-6 mt-4 lg:text-body-lg text-body-md text-gray-500 leading-6 space-y-6"
        >
          <span
            v-if="item?.isArray"
            class="flex flex-col"
            itemprop="text"
            v-for="i in item.content"
          >
            <NuxtLinkLocale @click="scrollToTopInSameUrl(i.link)" :to="i.link">
              {{ i.text }}

              <span
                v-if="i.badge"
                class="bg-orange-400 ml-2 text-white rounded-full text-body-sm px-2 py-1"
              >
                {{ i.badge }}
              </span>
            </NuxtLinkLocale>
          </span>
          <div v-html="item.content" v-else itemprop="text"></div>
        </HeadlessDisclosurePanel>
      </TransitionExpand>
    </div>
  </HeadlessDisclosure>
</template>

<script lang="ts" setup>
import type { IAccordionItem } from "~/types/components/accordion.type";

// * props
interface Props {
  item: IAccordionItem;
}

defineProps<Props>();
const slots = useSlots();

const hasTitleSlot = (name: string) => {
  return !!slots[name];
};
</script>
